module.exports = __webpack_public_path__ + "img/dc9a995.png";